import ContractorPortalPageShell from "../components/ContractorPortalPageShell";

const ContractorPaymentsPage = () => (
  <ContractorPortalPageShell
    title="پرداخت‌ها"
    description="درخواست‌ها و وضعیت پرداخت‌های پیمانکار (در فاز بعدی تکمیل می‌شود)."
    placeholderMessage="بخش پرداخت‌ها به‌زودی فعال می‌شود."
  />
);

export default ContractorPaymentsPage;
